export default "__VITE_ASSET__CI_i$hd$__"